import { all, takeEvery, put, fork } from "redux-saga/effects";

import axios from "./initialize";
import {
  GET_TEMPLATE_LIST,
  ADD_TEMPLATE,
  DELETE_TEMPLATE,
  UPDATE_TEMPLATE,
  GET_TEMPLATE_PAGE_DRAFT_LIST,
  ADD_TEMPLATE_PAGE_DRAFT,
  DELETE_TEMPLATE_PAGE_DRAFT,
  UPDATE_TEMPLATE_PAGE_DRAFT,
  GET_TEMPLATE_LIST_WITH_PAGES,
} from "redux/constants/templatePage";
import {templates,showTemplateMessage, templatePagesDraft, showTemplatePageDraftMessage, switchTabs, templatesWithPages} from "redux/actions/templatePage";
import trace from "auth/trace";
import { v4 as uuidv4 } from "uuid";
import { API_BASE_DEVELOPER_APP, API_BASE_URL } from "configs/AppConfig";
import { AUTH_TOKEN } from "redux/constants/Auth";
import { Modal,message } from "antd";
import { t } from "i18next";
import { CheckCircleFilled} from '@ant-design/icons';
import templatePages from "views/app-views/pages/apps/app-code/template-pages/template-page-list";


export function* getTemplateList() {
  yield takeEvery(GET_TEMPLATE_LIST, function* ({ payload }) {
    const {query,appId} = payload;
    const accountId = localStorage.getItem("accountId");
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId")
      },
    };
    try {
      const response = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/templates?accountId=${accountId}&appId=${appId}&query=${
          query
        }&sortBy=${payload?.sorter?.field}&sortDir=${
            payload?.sorter?.order
        }&pageNo=${payload?.pagination?.current - 1}&pageSize=${
            payload?.pagination?.pageSize
        }`,
        config
      );
      if (response.status === 200) {
        if(query!==undefined && query!==""){
            const traceObj ={
                type: `search_get_templates`,
                event: 'click',
                message: `${response?.data?.totalElements-1} results found for accountId=${accountId} and Keyword=${payload?.query}`,
                status: `templates retrieve successfully `,
                action: `Search get ${payload?.type}s`,
                referer_action_id: localStorage.getItem("referer_action_id"),
                trackId: uuidv4(),
                user_session: sessionStorage.getItem("user_session")
            };
                localStorage.setItem("referer_action_id",traceObj.trackId);
                trace({"traceObj":traceObj});
			}else{
            const traceObj ={
                type: `get_templates`,
                event: 'click',
                message: `${response?.data?.totalElements-1} results found for accountId=${accountId}`,
                status: `${response?.type}s retrieve successfully `,
                action: `clicked get templates`,
                referer_action_id: localStorage.getItem("referer_action_id"),
                trackId: uuidv4(),
                user_session: sessionStorage.getItem("user_session")
            };
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
			}		
        yield put(templates(response.data));
      }
    } catch (err) {
            if(query!==undefined && query!==""){
            const traceObj ={
                type: `search_get_templates`,
                event: 'click',
                message: `0 results found for keyword=${payload?.query} and accountId=${accountId}`,
                status: `Failed to retrieve templates`,
                action: `Search tp get templates`,
                referer_action_id: localStorage.getItem("referer_action_id"),
                trackId: uuidv4(),
                user_session: sessionStorage.getItem("user_session")
                };
                localStorage.setItem("referer_action_id",traceObj.trackId);
                trace({"traceObj":traceObj});
            }else{
                const traceObj ={
                type: `get_templates`,
                event: 'click',
                message: `0 results found for accountId=${accountId}`,
                status: `Failed to retrieve templates`,
                action: `clicked get templates`,
                referer_action_id: localStorage.getItem("referer_action_id"),
                trackId: uuidv4(),
                user_session: sessionStorage.getItem("user_session")
                };
                localStorage.setItem("referer_action_id",traceObj.trackId);
                trace({"traceObj":traceObj});
            }
            console.log(err);
            yield put(showTemplateMessage(err?.response));
    }
  });
}

export function* getTemplateListWithPages() {
  yield takeEvery(GET_TEMPLATE_LIST_WITH_PAGES, function* ({ payload }) {
    const {query,appId} = payload;
    const accountId = localStorage.getItem("accountId");
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
        accountId: localStorage.getItem("accountId"),
        appInstanceId: localStorage.getItem("appInstanceId"),
        accountUserId: localStorage.getItem("accountUserId")
      },
    };
    try {
      const response = yield axios.get(
        `${API_BASE_DEVELOPER_APP}/developerApp/templates/pages?accountId=${accountId}&appId=${appId}&query=${
          query
        }&sortBy=${payload?.sorter?.field}&sortDir=${
            payload?.sorter?.order
        }&pageNo=${payload?.pagination?.current - 1}&pageSize=${
            payload?.pagination?.pageSize
        }`,
        config
      );
      if (response.status === 200) {
             yield put(templatesWithPages(response.data));
      }
    } catch (err) {
            console.log(err);
            yield put(showTemplateMessage(err?.response));
    }
  });
}

export function* addTemplate() {
    yield takeEvery(ADD_TEMPLATE, function* ({ payload }) {
      try {
        const accountId = localStorage.getItem("accountId");
        const {appId,query}=payload;
        const config = {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
            accountId: localStorage.getItem("accountId"),
            appInstanceId: localStorage.getItem("appInstanceId"),
            accountUserId: localStorage.getItem("accountUserId")
          },
        };
        const res = yield axios.post(
          `${API_BASE_DEVELOPER_APP}/developerApp/templates`,
          payload,
          config
        );
        if (res.status === 201) {
          const traceObj ={
            type: `add_template`,
            event: 'click',
            message: `App template added successfully  for name=${payload?.name}`,
            status: `App template added successfully `,
            action: `Clicked template to add`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
            }; 
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
            const response = yield axios.get(
                `${API_BASE_DEVELOPER_APP}/developerApp/templates?accountId=${accountId}&appId=${appId}&query=${
                  query
                }&sortfield=${payload?.sorter?.field}&sortorder=${
                    payload?.sorter?.order
                }&page=${payload?.pagination?.current - 1}&size=${
                    payload?.pagination?.pageSize
                }`,
                config
              );
              if (response.status === 200) {
                Modal.success({
                  title: t("impaqx.adminApp.appTemplateSuccessMessage"),
                  icon: <CheckCircleFilled />,
                  okText: t("impaqx.adminApp.close"),
                  //cancelText: 'Cancel',
                  onOk() {
                    //deleteApp(id);
                  },
                });
                yield put(templates(response.data));
              }
            }
      } catch (error) {
        const traceObj ={
          type: `add_template`,
          event: 'click',
          message: ` Failed to add template name=${payload?.name}`,
          status: `Failed to add template`,
          action: `Clicked template to add`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
          }; 
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        console.log(error);
        // message.error(error?.response?.data?.error?error?.response?.data?.error:error?.response?.data?error?.response?.data:error?.response?error?.response:error);
        yield put(showTemplateMessage(error?.response));
      }
    });
  }
  
  export function* deleteTemplate() {
    yield takeEvery(DELETE_TEMPLATE, function* ({ payload }) {
      try {
        const accountId = localStorage.getItem("accountId");
        const config = {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
            accountId: localStorage.getItem("accountId"),
            appInstanceId: localStorage.getItem("appInstanceId"),
            accountUserId: localStorage.getItem("accountUserId")
          },
        };
        const res = yield axios.delete(
          `${API_BASE_DEVELOPER_APP}/developerApp/templates/${payload?.id}`,
          config
        );
        if (res.status === 200) {
          const traceObj ={
            type: `delete_template`,
            event: 'click',
            message: `template deleted for id=${payload?.id}`,
            status: `template deleted`,
            action: `Clicked delete template`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
            }; 
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          //yield put(showAccountMessage(res));
          const response = yield axios.get(
            `${API_BASE_DEVELOPER_APP}/developerApp/templates?accountId=${accountId}&appId=${payload?.appId}&query=${
              payload?.query
            }&sortfield=${payload?.sorter?.field}&sortorder=${
              payload?.sorter?.order
            }&page=${payload?.pagination?.current - 1}&size=${
              payload?.pagination?.pageSize
            }`,
            config
          );
          if (response.status === 200) {
            // message.success(`${payload.name}  ${t("impaqx.adminApp.appTemplateDeleteMessage")}`);
             Modal.success({
              title: `${payload.name}  ${t("impaqx.adminApp.appTemplateDeleteMessage")}`,
              icon: <CheckCircleFilled />,
              okText: "Close",
              //cancelText: 'Cancel',
              onOk() {
                //deleteApp(id);
              },
            });
            yield put(templates(response.data));
          }
        }
      } catch (error) {
        const traceObj ={
          type: `delete_template`,
          event: 'click',
          message: `Failed to delete template id=${payload.id}`,
          status: `Failed to delete template`,
          action: `Clicked to delete template`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
          }; 
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        console.log(error);
        // message.error(error?.response?.data?.error?error?.response?.data?.error:error?.response?.data?error?.response?.data:error?.response?error?.response:error);
        yield put(showTemplateMessage(error?.response));
      }
    });
  }

  export function* updateTemplate() {
    yield takeEvery(UPDATE_TEMPLATE, function* ({ payload }) {
      const appTemplate=payload;
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      try {
        const res = yield axios.put(
          `${API_BASE_DEVELOPER_APP}/developerApp/templates/${appTemplate?.id}`,
          appTemplate,
          config
        );
        if (res.status === 200) {
          const traceObj ={
              type: `update_template`,
              event: 'click',
              message: `template updated for id=${payload.id}`,
              status: `template updated`,
              action: `Clicked to update template`,
              referer_action_id: localStorage.getItem("referer_action_id"),
              trackId: uuidv4(),
              user_session: sessionStorage.getItem("user_session")
              }; 
              localStorage.setItem("referer_action_id",traceObj.trackId);
              trace({"traceObj":traceObj});
          const response = yield axios.get(
            `${API_BASE_DEVELOPER_APP}/developerApp/templates?accountId=${appTemplate?.accountId}&appId=${appTemplate?.appId}
            &query=${
              payload?.query
            }&sortfield=${payload?.sorter?.field}&sortorder=${
              payload?.sorter?.order
            }&page=${payload?.pagination?.current - 1}&size=${
              payload?.pagination?.pageSize
            }`,
            config
          );
          if (response.status === 200) {
            Modal.success({
                title: t("impaqx.adminApp.templateUpdateMessage"),
                icon: <CheckCircleFilled />,
                okText:t("impaqx.adminApp.close"),
                //cancelText: 'Cancel',
                onOk() {
                  //deleteApp(id);
                },
              });
            yield put(templates(response.data));
          }
        //   yield put(showTemplateMessage(res));
        }
      } catch (error) {
        const traceObj ={
          type: `update_template`,
          event: 'click',
          message: `Failed to update template for id=${payload.id}`,
          status: `Failed to update template`,
          action: `Clicked update template`,
          referer_action_id: localStorage.getItem("referer_action_id"),
          trackId: uuidv4(),
          user_session: sessionStorage.getItem("user_session")
          }; 
          localStorage.setItem("referer_action_id",traceObj.trackId);
          trace({"traceObj":traceObj});
        console.log(error);
        // message.error(error?.response?.data?.error?error?.response?.data?.error:error?.response?.data?error?.response?.data:error?.response?error?.response:error);
        yield put(showTemplateMessage(error?.response));
      }
    });
  }

  export function* getTemplatePageDraftList() {
    yield takeEvery(GET_TEMPLATE_PAGE_DRAFT_LIST, function* ({ payload }) {
      const {query,appId,templateId,selectedTab} = payload;
      const accountId = localStorage.getItem("accountId");
      const config = {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          accountId: localStorage.getItem("accountId"),
          appInstanceId: localStorage.getItem("appInstanceId"),
          accountUserId: localStorage.getItem("accountUserId")
        },
      };
      let url = `${API_BASE_DEVELOPER_APP}/developerApp/template-pages-draft?accountId=${accountId}&templateId=${templateId}&query=${query
      }&sortfield=${payload?.sorter?.field}&sortorder=${payload?.sorter?.order}&page=${payload?.pagination?.current - 1}&size=${payload?.pagination?.pageSize}`;
      if(selectedTab==="published"){
        url = `${API_BASE_DEVELOPER_APP}/developerApp/template-pages?accountId=${accountId}&templateId=${templateId}&query=${query
        }&sortfield=${payload?.sorter?.field}&sortorder=${payload?.sorter?.order}&page=${payload?.pagination?.current - 1}&size=${payload?.pagination?.pageSize}`;
      }
      try {
        const response = yield axios.get(
          url,
          config
        );
        if (response.status === 200) {
          if(query!==undefined && query!==""){
              const traceObj ={
                  type: `search_get_templates_pages_draft`,
                  event: 'click',
                  message: `${response?.data?.totalElements-1} results found for accountId=${accountId} and templateId=${templateId} and Keyword=${payload?.query}`,
                  status: `templates pages draft retrieve successfully `,
                  action: `Search get templates pages draft`,
                  referer_action_id: localStorage.getItem("referer_action_id"),
                  trackId: uuidv4(),
                  user_session: sessionStorage.getItem("user_session")
              };
                  localStorage.setItem("referer_action_id",traceObj.trackId);
                  trace({"traceObj":traceObj});
              }else{
              const traceObj ={
                  type: `get_templates_pages_draft`,
                  event: 'click',
                  message: `${response?.data?.totalElements-1} results found for accountId=${accountId} and templateId=${templateId}`,
                  status: `template pages draft retrieve successfully `,
                  action: `clicked get template pages draft`,
                  referer_action_id: localStorage.getItem("referer_action_id"),
                  trackId: uuidv4(),
                  user_session: sessionStorage.getItem("user_session")
              };
              localStorage.setItem("referer_action_id",traceObj.trackId);
              trace({"traceObj":traceObj});
              }		
          yield put(templatePagesDraft(response.data));
        }
      } catch (error) {
              if(query!==undefined && query!==""){
              const traceObj ={
                  type: `search_get_template_pages_draft`,
                  event: 'click',
                  message: `0 results found for keyword=${payload?.query} and accountId=${accountId} and templateId=${templateId}`,
                  status: `Failed to retrieve template pages draft`,
                  action: `Search tp get template pages draft`,
                  referer_action_id: localStorage.getItem("referer_action_id"),
                  trackId: uuidv4(),
                  user_session: sessionStorage.getItem("user_session")
                  };
                  localStorage.setItem("referer_action_id",traceObj.trackId);
                  trace({"traceObj":traceObj});
              }else{
                  const traceObj ={
                  type: `get_template_pages_draft`,
                  event: 'click',
                  message: `0 results found for accountId=${accountId} and templateId=${templateId}`,
                  status: `Failed to retrieve template pages draft`,
                  action: `clicked get template pages draft`,
                  referer_action_id: localStorage.getItem("referer_action_id"),
                  trackId: uuidv4(),
                  user_session: sessionStorage.getItem("user_session")
                  };
                  localStorage.setItem("referer_action_id",traceObj.trackId);
                  trace({"traceObj":traceObj});
              }
              console.log(error);
              // message.error(error?.response?.data?.error?error?.response?.data?.error:error?.response?.data?error?.response?.data:error?.response?.message?error?.response?.message:error?.response?.error?
                // error?.response?.error:error?.response?error?.response:error);
               yield put(showTemplatePageDraftMessage(error?.response));
      }
    });
  }
  
  export function* addTemplatePageDraft() {
      yield takeEvery(ADD_TEMPLATE_PAGE_DRAFT, function* ({ payload }) {
        const {values,publish}=payload;
        try {
          const accountId = localStorage.getItem("accountId");
          const config = {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
              Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
              accountId: localStorage.getItem("accountId"),
              appId: values?.appId,
              accountUserId: localStorage.getItem("accountUserId")
            },
          };
          const response = yield axios.post(
            `${API_BASE_DEVELOPER_APP}/developerApp/template-pages-draft`,
            values,
            config
          );
          if (response.status === 201) {
            if(publish==="publish"){
              const draftId = response?.data?.id;
            const publishResponse = yield axios.get(
              `${API_BASE_DEVELOPER_APP}/developerApp/template-pages/${draftId}/publish`,
              config
            );
            if (publishResponse.status === 201) {
              Modal.success({
                title: t("impaqx.adminApp.appTemplatePagePublishSuccessMessage"),
                icon: <CheckCircleFilled />,
                okText: t("impaqx.adminApp.close"),
                //cancelText: 'Cancel',
                onOk() {
                  //deleteApp(id);
                },
              });
            }
            }
            const traceObj ={
              type: `add_template_page_draft`,
              event: 'click',
              message: `template page draft added successfully  for name=${values?.pageName}`,
              status: `template page draft added successfully `,
              action: `Clicked template page draft to add`,
              referer_action_id: localStorage.getItem("referer_action_id"),
              trackId: uuidv4(),
              user_session: sessionStorage.getItem("user_session")
              }; 
              localStorage.setItem("referer_action_id",traceObj.trackId);
              trace({"traceObj":traceObj});
              if(publish!=="publish")
              Modal.success({
                title: t("impaqx.adminApp.templatePageDraftSuccessMessage"),
                icon: <CheckCircleFilled />,
                okText: t("impaqx.adminApp.close"),
                //cancelText: 'Cancel',
                onOk() {
                  //deleteApp(id);
                },
              });
              const tab = publish==="publish"?"published":"drafts";
              yield put(switchTabs(tab));
            }
        } catch (err) {
          const traceObj ={
            type: `add_template_page_draft`,
            event: 'click',
            message: ` Failed to add templatem page draft name=${values?.pageName}`,
            status: `Failed to add template page draft`,
            action: `Clicked template page draft to add`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
            }; 
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          console.log(err);
          // message.error(err?.response?.data?.error?err?.response?.data?.error:err?.response?.data?err?.response?.data:err?.response?err?.response:err);
          yield put(showTemplatePageDraftMessage(err?.response));
        }
      });
    }
    
    export function* deleteTemplatePageDraft() {
      yield takeEvery(DELETE_TEMPLATE_PAGE_DRAFT, function* ({ payload }) {
        const {templatePageDraft,selectedTab}=payload;
        try {
          const accountId = localStorage.getItem("accountId");
          const config = {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
              Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
              accountId: localStorage.getItem("accountId"),
              appInstanceId: localStorage.getItem("appInstanceId"),
              accountUserId: localStorage.getItem("accountUserId")
            },
          };
          var url = `${API_BASE_DEVELOPER_APP}/developerApp/template-pages-draft/${templatePageDraft?.id}`;
          if(selectedTab==="published"){
             url = `${API_BASE_DEVELOPER_APP}/developerApp/template-pages/${templatePageDraft?.id}`
          }
          const res = yield axios.delete(
            url,
            config
          );
          if (res.status === 200) {
            const traceObj ={
              type: `delete_template_page_draft`,
              event: 'click',
              message: `template page draft deleted for id=${templatePageDraft?.id}`,
              status: `template page draft deleted`,
              action: `Clicked delete template page draft`,
              referer_action_id: localStorage.getItem("referer_action_id"),
              trackId: uuidv4(),
              user_session: sessionStorage.getItem("user_session")
              }; 
              localStorage.setItem("referer_action_id",traceObj.trackId);
              trace({"traceObj":traceObj});
            //yield put(showAccountMessage(res));
            var tab = 'template-pages-draft';
            if(selectedTab==="published")
               tab = 'template-pages';
              const res = yield axios.get(
                `${API_BASE_DEVELOPER_APP}/developerApp/${tab}?accountId=${accountId}&templateId=${templatePageDraft?.templateId}&appId=${templatePageDraft?.appId}&query=${
                  payload?.query
                }&sortfield=${payload?.sorter?.field}&sortorder=${
                  payload?.sorter?.order
                }&page=${payload?.pagination?.current - 1}&size=${
                  payload?.pagination?.pageSize
                }`,
                config
              );
              if (res.status === 200) {
                var title = t("impaqx.adminApp.appTemplatePageDraftDeleteMessage");
                if(selectedTab==="published")
                  title = t("impaqx.adminApp.appTemplatePageDeleteMessage");
                Modal.success({
                  title: title,
                  icon: <CheckCircleFilled />,
                  okText: t("impaqx.adminApp.close"),
                  //cancelText: 'Cancel',
                  onOk() {
                    //deleteApp(id);
                  },
                });
                yield put(templatePagesDraft(res.data));
              }
          }
        } catch (err) {
          const traceObj ={
            type: `delete_template_page_draft`,
            event: 'click',
            message: `Failed to delete template page draft id=${templatePageDraft.id}`,
            status: `Failed to delete template page draft`,
            action: `Clicked to delete template page draft`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
            }; 
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          console.log(err);
          // message.error(err?.response?.data?.error?err?.response?.data?.error:err?.response?.data?err?.response?.data:err?.response?err?.response:err);
          yield put(showTemplatePageDraftMessage(err?.response));
        }
      });
    }
  
    export function* updateTemplatePageDraft() {
      yield takeEvery(UPDATE_TEMPLATE_PAGE_DRAFT, function* ({ payload }) {
        const {values,publish,status}=payload;
        const templatePageDraft=values;
        const accountId = localStorage.getItem("accountId");
        const config = {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
            Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
            accountId: localStorage.getItem("accountId"),
            appId: values?.appId,
            accountUserId: localStorage.getItem("accountUserId")
          },
        };
        try {
          const draftResponse = yield axios.put(
            `${API_BASE_DEVELOPER_APP}/developerApp/template-pages-draft/${templatePageDraft?.id}`,
            templatePageDraft,
            config
          );
          if (draftResponse.status === 200) {
            const draftId = draftResponse?.data?.id;
            if(publish==="publish"){
            const publishResponse = yield axios.get(
              `${API_BASE_DEVELOPER_APP}/developerApp/template-pages/${draftId}/publish`,
              config
            );
            if (publishResponse.status === 201) {
              var message =t("impaqx.adminApp.appTemplatePagePublishSuccessMessage");
              if(status)
               message = t("impaqx.adminApp.appTemplatePageStatusUpdateMessage");
              Modal.success({
                title:message ,
                icon: <CheckCircleFilled />,
                okText: t("impaqx.adminApp.close"),
                //cancelText: 'Cancel',
                onOk() {
                  //deleteApp(id);
                },
              });
            }
          }
            const traceObj ={
                type: `update_template_pages_draft`,
                event: 'click',
                message: `template pages draft updated for id=${payload.id}`,
                status: `template page draft updated`,
                action: `Clicked to update template page draft`,
                referer_action_id: localStorage.getItem("referer_action_id"),
                trackId: uuidv4(),
                user_session: sessionStorage.getItem("user_session")
                }; 
                localStorage.setItem("referer_action_id",traceObj.trackId);
                trace({"traceObj":traceObj});
                var message = t("impaqx.adminApp.templatePageDraftSuccessMessage");
                  if(status)
                    message = t("impaqx.adminApp.appTemplatePageStatusUpdateMessage")
                if(publish!=="publish")
                Modal.success({
                  title: message,
                  icon: <CheckCircleFilled />,
                  okText: t("impaqx.adminApp.close"),
                  //cancelText: 'Cancel',
                  onOk() {
                    //deleteApp(id);
                  },
                });
                const tab = publish==="publish"?"published":"drafts";
                yield put(switchTabs(tab));                  
          }
        } catch (error) {
          const traceObj ={
            type: `update_template_page_draft`,
            event: 'click',
            message: `Failed to update template page draft for id=${payload.id}`,
            status: `Failed to update template page draft`,
            action: `Clicked update template page draft`,
            referer_action_id: localStorage.getItem("referer_action_id"),
            trackId: uuidv4(),
            user_session: sessionStorage.getItem("user_session")
            }; 
            localStorage.setItem("referer_action_id",traceObj.trackId);
            trace({"traceObj":traceObj});
          console.log(error);
          // message.error(error?.response?.data?.error?error?.response?.data?.error:error?.response?.data?error?.response?.data?.message:error?.response?error?.response:error);
          yield put(showTemplatePageDraftMessage(error?.response));
        }
      });
    }

export default function* rootSaga() {
    yield all([
      fork(getTemplateList),
      fork(getTemplateListWithPages),
      fork(addTemplate),
      fork(deleteTemplate),
      fork(updateTemplate),
      fork(getTemplatePageDraftList),
      fork(addTemplatePageDraft),
      fork(deleteTemplatePageDraft),
      fork(updateTemplatePageDraft)
    ]);
  }
  